<template>
	<div class="title-header">
		<a href="https://www.odenseletbane.dk" title="Letbane" class="navbar-brand">
			<logo />
		</a>

		<router-link :to="{ path: '/' }" title="Fynbus" class="fynbus-logo">
			<img class="fynbus-logo--img" src="@/apps/fynbus/assets/images/fynbus-logo-transparent-bg.png" alt="Fynbus" />
		</router-link>

		<div class="items">
			<div class="items__content">
				<div class="languages">
					<template v-for="language in languages">
						<button
							v-if="selectedLanguage !== language.languageCode"
							:key="language.languageCode"
							:lang="language.languageCode"
							:aria-label="language.danishName"
							class="languages__button reset-button"
							@click.prevent="selectLanguage(language.languageCode)"
						>
							<img src="@/apps/fynbus/assets/images/globe-icon-updated.svg" class="languages__icon" />
							<span v-if="selectedLanguage === 'da'" class="languages__text">English</span>
							<span v-if="selectedLanguage === 'en'" class="languages__text">Dansk</span>
						</button>
					</template>
				</div>
				<button class="faq reset-button" @click.prevent="$emit('openHelp')">
					<img src="@/apps/fynbus/assets/images/faq-icon-updated.svg" class="faq__icon" />
					<span class="faq__text">{{ $t('letbane.help') }}</span>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { loadLanguageAsync, i18nInstance } from '@/i18n'

export default {
	computed: {
		languages() {
			const getSecondaryWebshop = this.$store.getters['system/getSecondaryWebshop']
			if (!getSecondaryWebshop) {
				return []
			}

			return getSecondaryWebshop.filter((webshop) => webshop.identifier === 'OdenseTram')[0].supportedLanguages
		},
		selectedLanguage() {
			return i18nInstance().locale
		},
	},
	mounted() {},
	methods: {
		selectLanguage(language) {
			// Load the language
			loadLanguageAsync(language, true)
		},
	},
}
</script>

<style lang="scss" scoped>
.title-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.fynbus-logo {
	position: absolute;
	left: calc(50% - 1.875rem);
	display: flex;
	justify-self: center;
	background: linear-gradient(to bottom, #95d450 0, #7fbc3b 100%);
	border: 0;
	border-radius: 0.3125rem;
	cursor: pointer;
	margin: 0;
	padding: 0.375rem;
	text-align: center;
	text-decoration: none;
	text-transform: uppercase;
	white-space: nowrap;

	&--img {
		width: 3.5rem;
	}
}

.items {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
}

.languages {
	display: flex;
	margin-bottom: 0.5rem;

	&__button {
		display: flex;
		align-items: center;
		flex-shrink: 0;
		cursor: pointer;
	}

	&__icon {
		margin-right: 0.5rem;
		width: 1.125rem;
		height: 1.125rem;
	}

	&__text {
		font-size: 0.875rem;
	}
}

.faq {
	display: flex;
	align-items: center;
	flex-shrink: 0;
	cursor: pointer;

	&__icon {
		margin-right: 0.5rem;
		width: 1.125rem;
		height: 1.125rem;
	}

	&__text {
		font-size: 0.875rem;
	}
}
</style>